import { shape, string } from 'prop-types'

export const targetPageParamsPropType = shape({
  targetPageCode: string,
  targetProductCode: string,
  targetAnchor: string,
})
